import React, { Component } from "react";
import sampleSize from "lodash/sampleSize";
import shuffle from "lodash/shuffle";
import moment from "moment";
import { connect } from "react-redux";
import "rc-checkbox/assets/index.css";
import "./WeeklyWins.css";
import axios from "./../../axios";
import * as url from "./../../utils/url";
import * as actionCreators from "../../modules/actions/index";
import { capitalizeFirstLetter } from "./../../utils/stringUtils";
import {
  weeklyWinsInspirations,
  table_column_names,
  planningValues
} from "../../utils/constants";
import Loading from "../../hoc/Loading/Loading";
import { orderBy } from "lodash";
import autosize from "autosize";
import ActionsTable from "./ActionsTable";
import { deepClone } from "../../utils/copyObject";
class WeeklyWins extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isRemoved: false,
      inspirations: [],
      taskType: "",
      limitValue: 15,
      skipValue: 0,
      inspirationsCount: 5,
      expanded: false,
      allTasks: [],
      favoriteChartCount: 0,
      favoriteToolCount: 0,
    };
    this.timer = null;

    this.weeklyWinsInput = null;
  }

  componentDidMount() {
    const unblock = this.props.history.block((location, action) => {
      if (action === "POP" && location.pathname === "/login") {
        return false;
      }
    });
    const unlisten = this.props.history.listen((location, action) => {
      if (action === "PUSH" && location.pathname === "/login") {
        unlisten();
        unblock();
      }
    });

    const inspirations = sampleSize(
      weeklyWinsInspirations,
      this.state.inspirationsCount
    );
    window.scrollTo(0, 0);
    autosize(this.weeklyWinsInput);
    this.setState({
      inspirations: inspirations,
    });
    const { kpiMasterList } = this.props.kpiMaster;
    const { mappingMasterList } = this.props.mappingMaster;
    const { organizationId } = this.props.user.profile;

    let that = this;
    let orgId = this.props.user.profile.organizationId._id;
    axios.get(url.findOrgById(orgId)).then(({ data }) => {
      const payload = data.data;
      that.props.orgChangeSuccess(payload);
    });

    if (kpiMasterList.length === 0) {
      axios.get(url.getKpiMaster).then(({ data }) => {
        const payload = data.data;
        this.props.onKpiMasterListFetched(payload);
      });
    }
    if (mappingMasterList.length === 0) {
      axios
        .get(url.getExistingMappings(organizationId._id))
        .then(({ data }) => {
          const payload = data.data;
          this.props.onMappingMasterListFetched(payload.mapping);
        });
    }

    this.setState({ taskType: this.props.match.url });
  }

  /**
   * load more/less Inpirations
   */
  loadMoreInpirations = () => {
    const count = this.state.expanded === true ? 5 : 10;
    const inspirations = sampleSize(shuffle(weeklyWinsInspirations), count);
    this.setState(currentState => ({
      inspirations: inspirations,
      inspirationsCount: count,
      expanded: !currentState.expanded,
    }));
  };

  /**
   * refresh Inpiraions list
   */
  renderGreeting = () => {
    const currentHour = moment().hour();
    const { profile } = this.props.user;
    let greeting = "";
    console.log(this.props.user, this.state.taskType);
    let taskType = this.state.taskType;
    if (taskType.indexOf("my") > -1) {
      if (currentHour >= 0 && currentHour < 12) {
        greeting = "Good Morning";
      } else if (currentHour >= 12 && currentHour < 18) {
        greeting = "Good Afternoon";
      } else {
        greeting = "Good Evening";
      }
      return (
        <span>
          {greeting}, {capitalizeFirstLetter(profile.firstName)}
        </span>
      );
    } else if (taskType.indexOf("office") > -1) {
      return <span> Office </span>;
    } else if (taskType.indexOf("enterprise") > -1) {
      return <span> Enterprise </span>;
    }
  };

  componentWillUnmount() {
    if (this.state.isRemoved) {
      this.props.onProfileUpdate({ hideIntro: true });
    }
  }

  getAllActions = filterApplied => {
    let taskType = this.props.match.url;
    const { skipValue, limitValue } = this.state;
    let skip = skipValue, publicObj, privateObj

    let limit = limitValue;

    planningValues.map(e=>{
      if(e.typeOf=='public'){
        publicObj = e
      }

      if(e.typeOf == "personal"){
        privateObj = e
      }
    })

    if (filterApplied === "APPLY") {
      skip = 0;
      limit = limitValue;
    }

    if (filterApplied === "CLEAR") {
      skip = 0;
    }

    const { filterParams } = this.props;

    if (taskType.includes(publicObj.link)) {
      taskType = publicObj.apiType
    }

    if (taskType.includes(privateObj.link)) {
      taskType = privateObj.apiType
    }



    axios
      .post(
        url.getTodos(taskType),
        { filters: filterParams.filtersDoc },
        { params: { skipValue:skip, limitValue:limit } }
      )
      .then(({ data }) => {
        let allTodos = data.data.taskList;
        allTodos = orderBy(
          allTodos,
          [
            ({ dueDate }) =>
              dueDate &&
              moment(dueDate).format("YYYY-MM-DD") <
                moment().format("YYYY-MM-DD")
                ? dueDate
                : dueDate && moment().diff(dueDate, "days") == 0
                ? dueDate
                : dueDate && moment().diff(dueDate, "days") > 0
                ? dueDate
                : dueDate == undefined || dueDate == null
                ? null
                : dueDate,
            "lastUpdate",
            "createdOn",
          ],
          ["asc", "desc", "desc"]
        );
        let favoriteCharts = data.data.favoriteChartCount;
        let favoriteTool = data.data.favoriteToolCount;
        this.setState(prevState => ({
          favoriteChartCount: favoriteCharts,
          favoriteToolCount: favoriteTool,
          allTasks:
            filterApplied === "APPLY" || filterApplied === "CLEAR"
              ? [...allTodos]
              : skip !=0 ? [...prevState.allTasks, ...allTodos]:[...allTodos],
          taskType,
        }));
      });
  };
  handleOnScrollPaginate = () => {
    this.setState(
      prevState => ({
        skipValue: prevState.skipValue + this.state.limitValue,
      }),
      () => {
        this.getAllActions();
      }
    );
  };
  render() {
    return (
      <div className="enterprise-actions col-md-11 col-sm-11">
        <div className="col-md-12 col-lg-12">
          <div className="weekly-wins-greeting-text">
            {this.renderGreeting()}
          </div>
          {/* <div className="weekly-wins-supporting-text mt10">
            <span>Plan and complete action(s) you can take towards</span>
            <br />
            <span>a diverse and inclusive workplace, and a winning team.</span>
          </div> */}
        </div>

        <div className="">
          {/* <div className="completed-todos-title">
            Actions ({pendingTodos.length})
          */}

          {/* <div class="row col-lg-8 col-md-8"><span class="col-md-4" style="
            text-align: center; "><span class="actionsByStatus progressList bgWhite">3<span style="
            display: block;
            font-size: 16px; ">In Progress</span> </span></span>
            <span class="col-md-4" style="
            text-align: center; "> <span class="actionsByStatus completedList">9
            <div style="
            font-size: 16px; "> Completed</div> </span> </span>
            <span class="col-md-4" style="
            text-align: center; ">  <span class="actionsByStatus overDueList"> 2 <div style="
            font-size: 16px; "> Past Due</div> </span></span></div> */}

          {/* </div> */}
          <br />
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <ActionsTable
                {...this.props}
                table_params={{
                  ...table_column_names["planning"],
                  selected: table_column_names["planning"]["1"],
                }}
                isHidden={true}
                getAllData={this.getAllActions}
                allTasks={this.state.allTasks}
                handleOnScrollPaginate={this.handleOnScrollPaginate}
                setAllTasks={(data)=>{this.setState({allTasks:deepClone([...data])})}}
                showTypeColumn={window.location.pathname.indexOf("my-activity") >= 0}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    filterParams: state.sortFilterParams.actions.filter,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: data =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: data =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: data =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    orgChangeSuccess: data => dispatch(actionCreators.orgChangeSuccess(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(WeeklyWins, axios));
